var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { inputFields } from "./data";
import config from "../../../assests/config";
import { Auth } from "aws-amplify";
export const initializeState = (config) => {
    return inputFields[config].fields.reduce((acc, data) => (Object.assign(Object.assign({}, acc), { [data.name]: "" })), {});
};
const handlePWCResponse = () => ({
    message: "",
    passwordChanged: false,
    nextAuth: "",
});
export const handleCPWC = ({ userInfo, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { newpassword, newpasswordagain } = userInfo;
        // if entered passwords not equal will return error message
        if (newpassword !== newpasswordagain)
            return Promise.reject(Object.assign(Object.assign({}, handlePWCResponse()), { message: config.errorMessages.PASS_NOT_MATCHED }));
        yield Auth.forgotPasswordSubmit(userInfo.email, userInfo.code, newpassword);
        return Promise.resolve(Object.assign(Object.assign({}, handlePWCResponse()), { passwordChanged: true, nextAuth: "LOGIN" }));
    }
    catch (error) {
        return Promise.reject(Object.assign(Object.assign({}, handlePWCResponse()), { message: config.errorMessages.SOMETHING_WRONG }));
    }
});
export const FTPSubmitHandler = ({ authenticatedUser, newpassword, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    try {
        return Auth.completeNewPassword(authenticatedUser.authUserInfo ||
            ((_a = authenticatedUser === null || authenticatedUser === void 0 ? void 0 : authenticatedUser.authenticatedUser) === null || _a === void 0 ? void 0 : _a.authUserInfo), newpassword);
    }
    catch (error) {
        console.error("FTPSubmitHandler: ", error);
        const message = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || config.errorMessages.SOMETHING_WRONG;
        return Promise.reject({
            message,
        });
    }
});
